import { Voyage } from "../../entities";
import { getAuthorRefForGateway, getAuthorRefFromGateway } from './ParsingUtils';
export default class VoyageParser {
    static toGateway(voyage, app) {
        return {
            Id: voyage._id,
            CreatedTimestamp: voyage.createdTimestamp,
            Author: getAuthorRefForGateway(voyage.author, app),
            VoyageNumber: voyage.voyageNumber,
            PortFrom: voyage.portFrom,
            PortTo: voyage.portTo,
            StartTime: voyage.startTime,
            EndTime: voyage.endTime,
            ETA: voyage.estimatedTimeOfArrival,
            Predecessor: voyage.predecessor,
        };
    }
    static fromGateway(gatewayVoyage, app) {
        const voyage = new Voyage({ author: getAuthorRefFromGateway(gatewayVoyage.Author, app) });
        voyage.voyageNumber = gatewayVoyage.VoyageNumber;
        voyage.portFrom = gatewayVoyage.PortFrom;
        voyage.portTo = gatewayVoyage.PortTo;
        voyage.startTime = gatewayVoyage.StartTime;
        if (gatewayVoyage.EndTime) {
            voyage.endTime = gatewayVoyage.EndTime;
        }
        if (gatewayVoyage.ETA) {
            voyage.estimatedTimeOfArrival = gatewayVoyage.ETA;
        }
        if (gatewayVoyage.Predecessor) {
            voyage.predecessor = Voyage.createRef(gatewayVoyage.Predecessor._id);
        }
        Object.assign(voyage, {
            _id: gatewayVoyage.Id,
            createdTimestamp: gatewayVoyage.CreatedTimestamp,
        });
        return voyage;
    }
}
//# sourceMappingURL=VoyageParser.js.map